import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiInsight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M30.121 2A3.88 3.88 0 0 1 34 5.879V30.12A3.88 3.88 0 0 1 30.121 34H5.88l-.2-.005A3.88 3.88 0 0 1 2 30.121V5.88a3.88 3.88 0 0 1 3.679-3.874l.2-.005zM5.88 4.6a1.28 1.28 0 0 0-1.28 1.279V30.12c0 .706.574 1.28 1.28 1.28H30.12a1.28 1.28 0 0 0 1.28-1.28V5.88a1.28 1.28 0 0 0-1.28-1.28zm12.115 7.236q.3 0 .422.158a.53.53 0 0 1 .158.334l1.722 11.281q.053.246-.088.387a.44.44 0 0 1-.316.14h-2.126q-.264 0-.387-.122a.64.64 0 0 1-.14-.282l-.3-1.757h-4.691l-1.054 1.793q-.087.123-.246.246-.14.123-.404.123H8.26q-.21-.001-.3-.176a.35.35 0 0 1 .019-.352l6.518-11.28q.105-.194.299-.335a.75.75 0 0 1 .492-.158zm8.991 0q.175 0 .282.123.105.124.07.316l-2.442 11.422a.5.5 0 0 1-.194.317.47.47 0 0 1-.316.123h-2.372a.37.37 0 0 1-.3-.123q-.105-.123-.07-.317l2.443-11.422a.5.5 0 0 1 .193-.316.54.54 0 0 1 .334-.123zm-13.489 7.608h3.268l-.65-4.638z"
	})]
});
const ForwardRef = forwardRef(SvgAiInsight);
export { ForwardRef as ReactComponent };
